import { useEffect, useState } from "react";
import { Col, Row } from "antd";
import { useBannerContext } from "../../../context/BannerContext/BannerContext";
import SwitchOptionComponent from "../../../components/SwitchComponent";

const BannerInfo = ({ hasNavigation, onHasNavigationChange }: { hasNavigation: boolean | undefined, onHasNavigationChange: (checked: boolean) => void }) => {
	const { bannerForm, bannerDetail, setBannerForm } = useBannerContext();
	const [isActive, setIsActive] = useState<boolean | undefined>(bannerDetail?.isActive);

	useEffect(() => {
		setIsActive(bannerDetail?.isActive);
	}, [bannerDetail?.isActive]);

	return (
		<>
			<Row gutter={20}>
				<Col span={8}>
					<SwitchOptionComponent
						key={"isActive"}
						title={"Aktiflik"}
						value={isActive}
						onChange={(checked) => {
							setIsActive(checked);
							setBannerForm({ ...bannerForm, isActive: checked });
						}}
					/>
				</Col>
				<Col span={8}>
					<SwitchOptionComponent
						key={"hasNavigation"}
						title={"Yönlendirme"}
						helperText={"Banner'a tıklandığında yönlendirme yapılmasını sağlar."}
						value={hasNavigation}
						onChange={(checked) => {
							onHasNavigationChange(checked);
						}}
					/>
				</Col>
			</Row >
		</>
	);
};

export default BannerInfo;
